var moduleMap = {
	".": () => {
		return Promise.all([__webpack_require__.e(734), __webpack_require__.e(832), __webpack_require__.e(806), __webpack_require__.e(358), __webpack_require__.e(80), __webpack_require__.e(975), __webpack_require__.e(446), __webpack_require__.e(395), __webpack_require__.e(322), __webpack_require__.e(191), __webpack_require__.e(736), __webpack_require__.e(984), __webpack_require__.e(318), __webpack_require__.e(684), __webpack_require__.e(703), __webpack_require__.e(939), __webpack_require__.e(605), __webpack_require__.e(24), __webpack_require__.e(101), __webpack_require__.e(164), __webpack_require__.e(838), __webpack_require__.e(223), __webpack_require__.e(155), __webpack_require__.e(67), __webpack_require__.e(949), __webpack_require__.e(336), __webpack_require__.e(599), __webpack_require__.e(123), __webpack_require__.e(652), __webpack_require__.e(935), __webpack_require__.e(655), __webpack_require__.e(378), __webpack_require__.e(52), __webpack_require__.e(718), __webpack_require__.e(84), __webpack_require__.e(450), __webpack_require__.e(213)]).then(() => (() => ((__webpack_require__(89213)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});